import { render, staticRenderFns } from "./returnAddress.vue?vue&type=template&id=2ad48eb5&scoped=true"
import script from "./returnAddress.vue?vue&type=script&lang=js"
export * from "./returnAddress.vue?vue&type=script&lang=js"
import style0 from "./returnAddress.vue?vue&type=style&index=0&id=2ad48eb5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad48eb5",
  null
  
)

export default component.exports